import { render, staticRenderFns } from "./StockInvestment.vue?vue&type=template&id=02ea2d82&scoped=true"
import script from "./StockInvestment.vue?vue&type=script&lang=js"
export * from "./StockInvestment.vue?vue&type=script&lang=js"
import style0 from "./StockInvestment.vue?vue&type=style&index=0&id=02ea2d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ea2d82",
  null
  
)

export default component.exports